<template>
  <modal
      id="promo-code-create-edit-modal"
      size="large"
      v-model="showModal"
      :title="from === 'user' ? generateModalTitle('user') : generateModalTitle('Promo Code')"
      @submit="submit"
      :loading="loading"
      :btn-label="selectedUrl ? $t('save') : $t('add')"
      :preloader="preloader">

    <form
        v-if="(isMailSettingExist || selectedUrl) && !preloader"
        ref="form"
        :data-url='
        selectedUrl ? selectedUrl : GET_PROMO_CODES'
        @submit.prevent="submitData"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="row d-flex flex-row align-items-end">
            <div class="col-md-6">
              <app-form-group
                  :label="$t('code')"
                  :placeholder="$placeholder('code')"
                  v-model="formData.code"
                  :required="true"
                  :error-message="$errorMessage(errors, 'code')"
              />
            </div>
            <div class="col-md-6 mb-4">
              <button type="button"
                      class="btn btn-primary"
                      @click="generatePromoCode()"
              >
                {{ $t('generate_code') }}
              </button>
            </div>
          </div>
          </div>
        <div class="col-md-12">
            <app-form-group
                :label="$t('usage_limit')"
                type="number"
                :placeholder="$placeholder('usage_limit')"
                v-model="formData.usage_limit"
                :required="true"
                :error-message="$errorMessage(errors, 'usage_limit')"
            />
        </div>
        <div class="col-md-12">
            <app-form-group
                :label="$t('expires_at')"
                type="date"
                :placeholder="$placeholder('expires_at')"
                v-model="formData.expires_at"
                :required="true"
                :error-message="$errorMessage(errors, 'expires_at')"
            />
        </div>
        <div class="col-md-12">
            <app-form-group
                :label="$t('days_extension')"
                :placeholder="$placeholder('days_extension')"
                v-model="formData.days_extension"
                :required="true"
                :error-message="$errorMessage(errors, 'days_extension')"
            />
        </div>
        <div class="col-md-12">
          <app-form-group
              :label="$t('status')"
              type="radio"
              :list="[
                {id:'1',value: $t('active')},
                {id:'0', value:  $t('inactive')},
            ]"
              v-model="formData.status"
              :error-message="$errorMessage(errors, 'status')"
          />
        </div>
      </div>

    </form>

    <template v-if="!isMailSettingExist && !selectedUrl" slot="footer">
      <button type="button"
              class="btn btn-secondary"
              data-dismiss="modal">
        {{ $t('close') }}
      </button>
    </template>
  </modal>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {
  GENERATE_PROMO_CODES,
  STORE_PROMO_CODE,
  GET_PROMO_CODES,
} from "../../../Config/ApiUrl";
import {
  TENANT_MAIL_CHECK_URL,
} from "../../../../common/Config/apiUrl";
import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import LogMixin from "../../Mixins/LogMixin";
import {addChooseInSelectArray} from "../../../../common/Helper/Support/FormHelper";

export default {
  name: "PromoCodeCreateEditModal",
  mixins: [FormHelperMixins, ModalMixin, LogMixin],
  props: {
    from: {
      type: String,
      default: 'promo_code'
    },
    subPackage: {
      type: Object,
      default: null
    },
    // subscriptionPackage: {
    //   type: {},
    //   default: null
    // },
    loaderColor: {
      type: String,
      default: 'white-color'
    }
  },
  data() {
    return {
      maps: null,
      isMailSettingExist: true,
      preloader: false,
      loading: false,
      // features: [],
      billingOptions: [
        { id: 'monthly', label: 'Monthly' },
        { id: 'yearly', label: 'Yearly' }
      ],
      // default_modules: ["job_desk","employee","attendance","leave","administration","payroll","location","asset"],
      moduleList: [
        // {label: 'Job Desk', id: 'job_desk'},
        {label: 'Employee', id: 'employee'},
        {label: 'Location', id: 'location'},
        {label: 'Attendance', id: 'attendance'},
        {label: 'Leave', id: 'leave'},
        {label: 'Administration', id: 'administration'},
        {label: 'Assets', id: 'assets'},
      ],
      formData: {
        code: "OFF_10",
        expires_at: '',
        days_extension: 30,
        usage_limit: 0,
      },
      STORE_PROMO_CODE,
      GET_PROMO_CODES,
    }
  },
  methods: {
    addFeature() {
      // this.formData.package_feature.push('');
      this.formData.package_feature.push({
        subscription_package_id: this.formData.id || null,
        feature: ''
      });
    },
    generatePromoCode(){
      axiosGet(GENERATE_PROMO_CODES).then(response => {
        this.formData.code = response.data.code;
      }).finally(() => {
        this.preloader = false;
      });
    },
    removeFeature(index) {
      // this.formData.features.splice(index, 1);
      this.formData.package_feature.splice(index, 1);
    },
    submit() {
      // console.log(this.formData);
      // this.formData.modules = JSON.stringify(this.formData.modules);
      // this.formData.features = this.features;
      this.fieldStatus.isSubmit = true;
      // this.formData.duration = parseInt(this.formData.duration);
      // this.formData.modules = JSON.stringify(this.formData.modules);
      this.loading = true;
      this.message = '';
      this.errors = {};
      // this.formData.alias = formatDateForServer(this.formData.contract_start_date);
      this.submitData(this.formData);
    },
    afterSuccess({data}) {
      this.formData = {};
      $('#promo-code-create-edit-modal').modal('hide');
      this.$emit('input', false);
      this.toastAndReload(data.message, this.from === 'package' ? 'package-table' : 'user-table');
      if (this.from === 'promo_code') {
        this.$hub.$emit(`reload-promo-code-table`)
      }
    },
    afterSuccessFromGetEditData({data}) {
      // this.formData.modules = JSON.parse(data.modules);
      // console.log(data);
      // this.arrays = addChooseInSelectArray(data.modules, 'modules', this.$t('modules'));
      this.formData = {
        ...this.formData,
        ...data,
        // modules: data.modules.map(moduleId => {
        //   return this.moduleList.find(module => module.id === moduleId);
        // })
      };
      // this.formData.modules = this.arrays[1];
      // console.log(this.formData.modules);

      // this.formData = {...this.formData, ...data};

    },
    checkMailSettings() {
      this.preloader = true;
      axiosGet(TENANT_MAIL_CHECK_URL).then(response => {
        this.isMailSettingExist = !!response.data;
      }).finally(() => {
        this.preloader = false;
      });
    },
    generateModalTitle(subject) {
      return this.$fieldTitle(this.selectedUrl ? 'edit' : 'add', subject, true);
    },
  },
  created() {
    this.addFeature();
    if (this.selectedUrl) {
      // this.formData = this.subPackage;
      // this.checkEmployeeID();
      // this.features = JSON.parse(this.features);
    }
    else {
      this.addFeature();
    }
  },
  watch: {
    'formData.modules': {
      handler: function(value) {
        if (JSON.stringify(value) !== JSON.stringify(this.formData.modules)) {
          this.formData = {
            ...this.formData,
            modules: value
          };
        }
        this.preloader = false;
      },
      deep: true
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  mounted() {},
}
</script>